import { SvgIcon, SvgIconProps } from "@mui/material";

export const ReleaseNotesIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M19 21v0a2 2 0 0 0 2-2v-6a1 1 0 0 0-1-1h-3v7a2 2 0 0 0 2 2Z"
        clip-rule="evenodd"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M7 8h6M7 11.87h6M7 16.06h3M17 12V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v14a2 2 0 0 0 2 2h14"
      />
    </svg>
  </SvgIcon>
);
